"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Lightbulb16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.58419 8.54841C9.13508 8.82858 8.81536 9.27536 8.69508 9.79084L8.41294 11H7.58705L7.3049 9.79082C7.18462 9.27535 6.8649 8.82857 6.4158 8.54841C5.56136 8.01537 5 7.07245 5 6C5 4.34315 6.34315 3 8 3C9.65685 3 11 4.34315 11 6C11 7.07246 10.4386 8.01538 9.58419 8.54841ZM10.2524 11.9181L10.6428 10.2453C12.0582 9.36231 13 7.79114 13 6C13 3.23858 10.7614 1 8 1C5.23858 1 3 3.23858 3 6C3 7.79114 3.94181 9.3623 5.35722 10.2453L5.74756 11.9181C5.89541 12.5517 6.46029 13 7.11094 13H8.88906C9.53971 13 10.1046 12.5517 10.2524 11.9181ZM8 16C6.89543 16 6 15.1046 6 14H10C10 15.1046 9.10457 16 8 16Z", fill: "#131416" }));
}
function Lightbulb16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Lightbulb16Svg, Object.assign({}, svgProps)));
}
exports.default = Lightbulb16;
//# sourceMappingURL=Lightbulb16.js.map